import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import type { ChangeEventHandler, SyntheticEvent } from 'react';
import { ItemWithLabel } from '../utils';
import TextField, { TextFieldProps } from './TextField';

export function MultiSelectField({
  name,
  onBlur,
  onChange,
  options,
  sx,
  value,
  ...rest
}: MultiSelectFieldProps) {
  const textFieldProps = rest as any;
  const selectedValues = options.filter((option) => {
    return value?.includes?.(option.value);
  });

  function onAutocompleteChange(_event: SyntheticEvent, newValues: any[]) {
    onChange?.({ name: name || '', value: newValues.map((opt) => opt.value) });
  }

  return (
    // The margin belongs to the wrapper, so `sx` controls the whole field
    <Box sx={{ mt: 2, ...sx }}>
      <Autocomplete
        ChipProps={{
          sx: { height: 25 },
        }}
        getOptionLabel={(option) => option.label as string}
        limitTags={2}
        multiple
        onChange={onAutocompleteChange}
        options={options}
        renderInput={(params) => (
          <TextField {...textFieldProps} {...params} sx={{ mt: 0 }} />
        )}
        value={selectedValues}
      />
    </Box>
  );
}

export interface MultiSelectFieldProps extends Omit<
  TextFieldProps,
  'onChange'
> {
  name?: string;
  onBlur?: ChangeEventHandler;
  onChange?: (event: { name: string; value: string[] }) => void;
  options: ItemWithLabel[];
  value?: string[];
}
